
<ebs-activity-group [isSectionHeader]='true' [activityGroup]='firstGroup'></ebs-activity-group>

@if (section) {
  <div>
    <!-- <div *ngFor="let activityGroup of section.activityGroups">
    <ebs-activity-group [activityGroup]='activityGroup'></ebs-activity-group>
  </div> -->
  @for (activityGroup of activityGroupsWithoutHeader; track activityGroup) {
    <div>
      <ebs-activity-group [activityGroup]='activityGroup'></ebs-activity-group>
    </div>
  }
</div>
}